import { createSlice } from '@reduxjs/toolkit';

import { fetchService, fetchServices } from './servicesThunks';
import { SERVICES_SLICE_NAME } from '../slicesNames';
import { type ServicesState } from './services.types';

const initialState: ServicesState = {
  isLoading: false,
  error: null,
  services: {},
  nameMap: {},
};

const servicesSlice = createSlice({
  name: SERVICES_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchService.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchService.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || 'Failed to fetch services';
      })
      .addCase(fetchService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;

        const serviceData = action.payload;

        state.services[serviceData.serviceId] = serviceData;
        state.nameMap[serviceData.serviceName.toLowerCase()] = serviceData;
      });

    builder
      .addCase(fetchServices.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchServices.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || 'Failed to fetch services';
      })
      .addCase(fetchServices.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;

        const servicesData = action.payload;

        for (const service of servicesData) {
          state.services[service.serviceId] = service;
          state.nameMap[service.serviceName.toLowerCase()] = service;
        }
      });
  },
});

export default servicesSlice;
